/**
 * Public legal documents served as path-based "routes" (App.js inspects
 * `window.location.pathname`; there is no react-router).
 *
 * Only the routing facts live here. The text, version, and counsel-approval
 * status come from the backend (GET /api/legal/documents/{key}) and are edited
 * and published from Admin → Legal documents.
 */
export const LEGAL_DOCUMENTS = {
  privacy: {
    key: 'privacy',
    path: '/privacy',
    title: 'Privacy Notice',
  },
  terms: {
    key: 'terms',
    path: '/terms',
    title: 'Terms of Service',
  },
};

/**
 * Return the legal document for a pathname, or null.
 *
 * @param {string} pathname - e.g. window.location.pathname.
 * @returns {object|null}
 */
export const legalDocumentForPath = (pathname) => {
  const normalized = String(pathname || '').replace(/\/+$/, '') || '/';
  return Object.values(LEGAL_DOCUMENTS).find((doc) => doc.path === normalized) || null;
};
